module.exports = __webpack_public_path__ + "img/logo2.1bca55d3.png";